import { NumberSetting } from 'modules/Editor/components/SideMenuSettings/ChartSettings';
import { SideSettingDivider } from 'modules/Editor/components/SideMenuSettings/SidemenuSettingsDivider';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isFiniteNumber } from 'utils/number';
import { useWidget } from 'widgets/sdk';

import { HistogramChartWidgetData } from './histogramChartWidget.types';

export const ChartStyle = () => {
  const {
    generalOptions: { binSize },
    updateWidget,
  } = useWidget<HistogramChartWidgetData>();
  const initialBinSize = isFiniteNumber(binSize) ? binSize.toString() : '';
  const [binSizeCache, setBinSizeCache] = useState(initialBinSize);

  const { t } = useTranslation('chart_widget', { useSuspense: false, keyPrefix: 'histogram' });
  const label = t('binSize');
  const placeHolder = t('binSizePlaceholder');

  const onChangeBinSize = (valueAsString: string) => {
    setBinSizeCache(valueAsString);
  };

  const onBlurBinSize = () => {
    const valueAsNumber = binSizeCache === '' ? NaN : Number(binSizeCache);
    updateWidget({
      generalOptions: {
        binSize: valueAsNumber,
      },
    });
  };

  return (
    <>
      <SideSettingDivider marginY={4} />
      <NumberSetting
        label={label}
        min={0}
        value={binSizeCache}
        onBlur={onBlurBinSize}
        onChange={onChangeBinSize}
        placeholder={placeHolder}
        size={'sm'}
        step={1}
        width={28}
        height={7}
      />
    </>
  );
};
